import { render, staticRenderFns } from "./materSale.vue?vue&type=template&id=639563fa&"
import script from "./materSale.vue?vue&type=script&lang=js&"
export * from "./materSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports